var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.mainComponent.is,_vm._g(_vm._b({tag:"component",scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true)},'component',_vm.mainComponent.props,false),_vm.mainComponent.events),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }